import clsx from 'clsx';
import { useMapButtonLinkToProps } from '@/hooks';
import React from 'react';
import useStyles from './CtaItem.styles';
import { MuiButton } from '@/features/shared/material-ui';

export type CtaItemProps = {
  className?: string;
  link?: LinkType;
};

const CtaItem = ({ link, className, ...restProps }: CtaItemProps) => {
  const { mapButtonLinkToProps } = useMapButtonLinkToProps();
  const classes = useStyles();
  const ctaProps = mapButtonLinkToProps(link);

  return (
    <div className={clsx(className)} {...restProps}>
      <MuiButton variant="contained" color="secondary" className={classes.link} {...ctaProps}>
        <span className={classes.buttonText}>{link?.displayText}</span>
      </MuiButton>
    </div>
  );
};

export default CtaItem;
